import { DICA_REGISTRIES } from "./dica-registries";

export type RegistryTenant = "dica" | "niv" | "swab" | "pice" | "rivm" | "dicawgz" | "none" | "idr";

export const REGISTRY_TENANTS_LOOKUP: { [tenantId in RegistryTenant]: string[] } = {
    dica: DICA_REGISTRIES,
    niv: ["Draim", "Demo"],
    idr: ["Icra"],
    swab: ["AmsmReporting"],
    pice: ["Pice", "PiceW"],
    rivm: ["Gli"],
    dicawgz: ["DcraWgz", "DhfaWgz"],
    none: ["Born", "BornV3", "Hened", "Nbrr3"], // this list is here so that all registries show up in data-request
};

export const DEFAULT_DOMAIN = "nl.mrdm.com";
export const TENANT_DOMAINS = [{ domain: "ca.mrdm.com", tenant: ["idr"] }];

export const ALL_REGISTRIES = Object.values(REGISTRY_TENANTS_LOOKUP).reduce(
    (allRegistries, tenantRegistries) => [...allRegistries, ...tenantRegistries],
);
